const answerReviewPermissions = {
    followups: {
        index: (_session) => true,
        edit: (_session) => true,
        show: (_session) => true,
        new: (_session) => true,
        delete: (_session) => true,
    },
};
export default answerReviewPermissions;
